module.exports = __webpack_public_path__ + "static/media/icon-current-play.01b9d2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-current-play.png
// module id = 1882
// module chunks = 6